// <partners:imports>
import eastshipper from "./eastshipper/config";
import pmpaket from "./pmpaket/config";
import sabo from "./sabo/config";
// </partners:imports>

// Explicit partner inventory. Adding a partner = create src/partners/{id}/
// (Logo.tsx + config.ts) and append the import here. Kept explicit (rather
// than webpack require.context) so Jest, webpack, and any future bundler
// see the same list — and so reading this file tells you which partners
// the bundle ships with.
//
// The <partners:*> marker blocks are rewritten by scripts/new-partner. Don't
// rename them; do edit entries by hand if needed (alphabetical, one per line).
export const ALL_PARTNERS: ReadonlyArray<unknown> = [
  // <partners:registry>
  eastshipper,
  pmpaket,
  sabo,
  // </partners:registry>
];
